import { render, staticRenderFns } from "./DetailCekGadai.vue?vue&type=template&id=571fcf4b&scoped=true&"
import script from "./DetailCekGadai.vue?vue&type=script&lang=js&"
export * from "./DetailCekGadai.vue?vue&type=script&lang=js&"
import style0 from "./DetailCekGadai.vue?vue&type=style&index=0&id=571fcf4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571fcf4b",
  null
  
)

export default component.exports